import {CalculatorCreditTypes, RecieveMoneyMethodsType} from "@/types_and_interfaces/types";
import React from "react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import CalculatorLimit from "@/types_and_interfaces/calculator_limit.ts";
import useCalc from "@/hooks/calculator.ts";
import CalculatorLimitTypes from "@/types_and_interfaces/calculator_limit_types.ts";


interface SwitcherProps {
    creditType:CalculatorCreditTypes | RecieveMoneyMethodsType
    types:Array<any>
    switchCrType(x:string):void
    styles:any
    recieve?:boolean
}


const SwitcherDesktop:React.FC<SwitcherProps> = (props:SwitcherProps) => {
    const calc = useCalc()
    const  {
        styles,
    } = props;
    
    
    
    return (
        <div className={clsx(styles.switcher_desktop)}>
            {(() => {
                const types: CalculatorLimitTypes | {} | undefined = calc.get_types();
                
                return (!types || Object.keys(types).length === 0)
                    ? [{}, {}, {}].map((obj, i) => (
                        <TypeSwitcher styles={styles} key={"CrTypeSwitcher" + i} obj={obj}/>
                    ))
                    : Object.keys(types).map((key, i) => (
                        // @ts-ignore
                        <TypeSwitcher styles={styles} key={"CrTypeSwitcher" + i} obj={types[key]}/>
                    ));
            })()}
        </div>
    )
}


interface Props {
    obj: CalculatorLimit | undefined | {}
    styles: any
}


const TypeSwitcher: React.FC<Props> = ({obj, styles}) => {
    const {t} = useTranslation()
    const local_limit = obj as CalculatorLimit
    const calc = useCalc()
    const selected = calc.get_selected_type() as CalculatorLimit
    
    return (
        <div
            className={clsx(
                styles.sw_item,
                styles[local_limit.category_name],
                (selected?.category_name === local_limit.category_name && Object.keys(local_limit).length) && styles.selected
            )}
            onClick={() => {
                calc.type_handle(local_limit)
            }}
        >
            <div className={styles.sw_item_inner}>
                {t(local_limit.category_name)}
            </div>
        </div>
    )
}


export default SwitcherDesktop